import Links from '@/shared/constants/navegacao';
import { ApiReturn } from '@/modules/api.service';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { GetDefensorias } from '@/modules/structure/defensoria/defensoria.service';
import { Link } from 'react-router-dom';
import { ReadComarcaDto, ReadDefensoriaDto, ReadVaraDto } from '@/api.types';
import { readComarca } from '@/modules/structure/comarca/comarca.service';
import { readVara } from '../vara/vara.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function DefensoriaIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<ApiReturn<ReadDefensoriaDto>>({ objects: [], count: 0 });
  const tableState = useDataTableState('nome');

  const [varas, setVaras] = useState<ReadVaraDto[]>([]);
  const [varaid, setVaraId] = useState<number>(0);
  const [comarcas, setComarcas] = useState<ReadComarcaDto[]>([]);
  const [comarcaid, setComarcaId] = useState<number>(0);

  useEffect(() => {
    Promise.all([
      readVara({ skip: 0, take: 1000, orderBy: 'ASC', orderField: 'nome' }),
      readComarca({ skip: 0, take: 1000, orderBy: 'ASC', orderField: 'nome' }),
    ])
      .then((result) => {
        setVaras(result[0][0]);
        setComarcas(result[1][0]);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  useEffect(() => {
    handleBuscar();
  }, [varaid, comarcaid]);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Defensoria_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  const handleBuscar = () => {
    GetDefensorias(
      (tableState.currentPage - 1) * tableState.pageSize,
      tableState.pageSize,
      varaid,
      comarcaid,
      tableState.filter,
    )
      .then((result) => {
        setRegistros(result);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  };

  let colunas: Column<ReadDefensoriaDto>[] = [
    { key: "ordem", header: "Ordem" },
    { key: "nome", header: "Nome" },
    { key: "vara.nome", header: "Vara" },
    { key: "comarca.nome", header: "Comarca" },
    { key: "predio.nome", header: "Unidade" },
    { key: "diretoria.nome", header: "Diretoria" },
    {
      key: "lotacoes", header: "Lotações", render: (row) =>
        <Link className="link-secondary" to={Links.Vinculos_Index + '?tipo=defensor&defensoriaid=' + row.id}>
          {(row as any).lotacoes?.length || 0}
        </Link>
    },
    { key: "movimentacoes.length", header: "Movimentações" },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Defensoria_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Defensorias</h3>
          <span className="blockquote-footer pb-4 text-end">
            Defensorias cadastradas no sistema.
          </span>
        </div>

        <hr className="pb-4" />

        {registros &&
          <DataTable
            columns={colunas}
            data={registros.objects}
            initialSortKey="nome"
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros.count}
            renderFilters={() => (
              <div className='row ms-2'>
                <div className="col-md-5">
                  <select
                    title="Vara"
                    className="form-select mt-3"
                    id="vara"
                    name="vara"
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                      setVaraId(e.target.value as unknown as number)
                    }
                  >
                    <option value={0}>(todas as varas)</option>
                    {varas !== undefined &&
                      varas !== null &&
                      varas.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nome}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-md-5 mt-3">
                  <select
                    title="Comarca"
                    className="form-select"
                    id="comarca"
                    name="comarca"
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                      setComarcaId(e.target.value as unknown as number)
                    }
                  >
                    <option value={0}>(todas as comarcas)</option>
                    {comarcas !== undefined &&
                      comarcas !== null &&
                      comarcas.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nome}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            )}
          />
        }
      </div>
    </>
  );
}